import React from "react";
import {Container, IntroPar, Box} from "../styles/intro_styles";
import {StartButton} from "../styles/stepper_styles.js";

export default function Introduction(props) {
  return (
    <Container>
      <Box>
        <IntroPar>
        Rotom is a data augmentation (DA) technique that transforms existing labeled examples
         to generate additional examples for training NLP models. It is especially advantageous
         in low-resources settings with few labels.
         <br /><br />
        Rotom works with existing DA operators such as word replacement or deletion but also comes
        with a new operator, InvDA, to &quot;invert&quot; corrupted augmentations.

          <br />
          <br /> Go ahead and try it yourself!
          <br />
          <br />
        </IntroPar>
        {props.activeStep === -1 ? (
          <StartButton onClick={props.handleNext}>Start</StartButton>
        ) : (
          ""
        )}
      </Box>
    </Container>
  );
}

// <PubLink onclick="window.open('https://dl.acm.org/doi/10.1145/3431816','_blank')">
//   {" "}
//   Read our publication{" "}
// // </PubLink>
